import {Grid, SnackbarContent, withStyles} from "@material-ui/core";
import * as PropTypes from "prop-types";
import style from "./styles";
import React from "react";
import {makeStyles} from "@material-ui/styles";
import * as classnames from "classnames";

const useStyles = makeStyles(theme => {
    return ({
        error: {
            backgroundColor: theme.palette.error.light,
            color: theme.palette.text.primary
        },
        // Sem laranja na marca: reaproveita o amarelo já usado no gauge de
        // horas (Chart/utils.js) para o nível "alerta".
        alert: {
            backgroundColor: '#ffee58',
            color: theme.palette.text.primary
        }
    })
});

const SnackMessage = (props) => {
    const classes = useStyles();
    const {form, fieldSchema: schema} = props;
    return <Grid item {...(schema.sizes ?? {})}>
                {
                    ['error', 'alert'].includes(form.values[schema.field]) && form.values['requestMessage'] ? <SnackbarContent elevation={0} className={classnames(classes?.[form.values[schema.field]])} message={form.values['requestMessage']}/> : <React.Fragment/>
                }
    </Grid>;
};

SnackMessage.propTypes = {
    classes: PropTypes.any,
    data: PropTypes.any
};

export default withStyles(style)(SnackMessage);
